import React, {useState} from 'react';
import {Link} from 'react-router-dom'

// Interface for component props
interface ConfirmEmailCodeProps {
    onConfirmCode: (emailCode: string) => void;
}

export default function ConfirmEmailCode({onConfirmCode}: ConfirmEmailCodeProps) {

    return (

        <form action="/user/confirm-email-code" onSubmit={handleSubmit}>
        <div className="form-group">
            <input
                type="emailCode"
                id="emailCode"
                name="emailCode"
                className="form-control"
                placeholder="Enter code from the email"
            />
            </div>
            <button type="submit" className="btn btn-primary btn-block">
                Submit
            </button>
        </form>
    )

    function handleSubmit(event: React.FormEvent<HTMLFormElement>) {
    

        console.log(`in email code submit`)
        event.preventDefault();
    
        const form = event.currentTarget;
        const emailCodeElement = form.elements.namedItem('emailCode') as HTMLInputElement;
        const emailCode = emailCodeElement.value;
     
        console.log(`in email code submit 2`)
        // callback to parent
        onConfirmCode(emailCode);
    }
}